/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreferredIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PreferredIcon({
  children,
  viewPath = "/DesignSystem/PatientOverview/Content/Contact/Content/Emails/Content/Email/PreferredIcon"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let emailPreferenceValueData = fromData.useDataValue({ viewPath,
context: 'email',
path: 'preference',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(emailPreferenceValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}